import React from "react"
import { Box, Container, Typography, useTheme } from "@mui/material"
import ResponsiveBackground from "components/ResponsiveBackground"
import useScopedTranslation from "hooks/useScopedTranslation"
import en from "./locales/en.json"
import Link from "components/Link"

export const namespace = __filename

const CounterfeitReport = () => {
  const theme = useTheme()
  const { t } = useScopedTranslation(
    namespace,
    (locale) => import(`./locales/${locale}.json`),
    en
  )

  return (
    <ResponsiveBackground theme={theme}>
      <Container
        sx={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Box style={{ marginRight: 10 }}>
          <Typography fontWeight={theme.tokens.fonts_Conti.fontWeight_heavy}>
            {t("contactEmail")}
          </Typography>
          <Link
            variant={"body1"}
            text={"productandbrandprotection@continental.com"}
            path={"mailto:productandbrandprotection@continental.com"}
            style={{ color: theme.palette.primary.main, fontWeight: "bold", marginTop: 5, fontSize: "1rem"}}
          />
        </Box>
      </Container>
    </ResponsiveBackground>
  )
}

export default CounterfeitReport
